import { backgroundColorHoverNormal, backgroundColorNormal, ColorBlueDark, textColorWhite } from './palette';

export const tableFooterButtonTextColor = textColorWhite;
export const tableFooterButtonBg = backgroundColorNormal;
export const tableFooterButtonBgHover = ColorBlueDark;
export const tableFooterMenuButtonBg = 'none';
export const tableFooterMenuButtonBgHover = backgroundColorHoverNormal;
